import { z } from 'zod';
import { baseCustomFieldSchema } from '@/features/dashboard/tourCustomFields/schemas/baseCustomFieldSchema.ts';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';

export const checkboxCustomFieldSchema = baseCustomFieldSchema.extend({
  type: z.literal(FieldType.CHECKBOX),
  defaultValue: z.boolean({ error: 'Pole wymagene' }),
});

export type CheckboxCustomFieldInputData = z.input<
  typeof checkboxCustomFieldSchema
>;
export type CheckboxCustomFieldFormData = z.infer<
  typeof checkboxCustomFieldSchema
>;
